import {emptyForm, enableFormBack, handleApiForm, handleValidationErrors, renderList} from "../forms";
import {toastAlert} from "../toastAlert";
import {closeModal, openModal, redirect, url} from "../utilities";
import Spinner from "../spinner";
import axios from "axios";
import * as $ from "jquery";
import {toLonLat} from "ol/proj";
import {handleShpForm} from "../shp";
import {confirmModal} from "../confirmModal";

export const associations = () => {
    // Forms
    let body = $("body");
    handleApiForm("#editAssociationAddress", function ({response}) {
        let modalInstance = bootstrap.Modal.getInstance(document.getElementById("editAddressModal"));
        modalInstance.hide();

        toastAlert('Adres został pomyślnie edytowany');

        $('#editAssociation_address').val(response.data.address);
    })

    handleApiForm("#addDistrict", function ({response}) {
        let modalInstance = bootstrap.Modal.getInstance(document.getElementById("addDistrictModal"));
        modalInstance.hide();

        redirect(`admin/districts/${response.data.id}/edit`);
    })

    $("input[name='is_extended_authorizations_module_enabled']").change(function () {
        let input = $("input[type='checkbox'][name='is_restricted_authorizations_module_enabled']").closest('.col-12');

        if ($(this).prop('checked')) {
            input.show();
        } else {
            input.hide();
        }
    })

    $("#addMember input[name='login']").change(async function () {
        let spinner = new Spinner();

        try {
            let association_id = $("#association_id").val();
            let response = await axios.get(url(`api/users/${$(this).val()}?association_id=${association_id}`));

            for (let field in response.data) {
                if (response.data.hasOwnProperty(field)) {
                    $(`input[name='${field}']`).val(response.data[field]);
                }
            }

            if (response.data.in_current) {
                $(".error[data-for='login']").text('Osoba z podanym loginem już jest członkiem koła.');
                $("button[type='submit']").attr('disabled', true);
            }

            $("input[name='password']").attr('disabled', true);

            spinner.destroy();
        } catch (err) {
            $("input[name='password']").attr('disabled', false);
            $("button[type='submit']").attr('disabled', false);
            $(".error[data-for='login']").text('');
            spinner.destroy();
        }

        if ($("#addMember_email").val() !== "" && !$("#addMember_password").attr("disabled")) {
            $("#addMember_send_password").attr('disabled', false)
        } else {
            $("#addMember_send_password").attr('disabled', true)
        }

        let loginPattern = /^[a-zA-Z]\d{8}$/; // Pattern: one letter followed by 8 digits
        let errorMessage = document.querySelector('#warning-message');

        if (!loginPattern.test($("#addMember input[name='login']").val())) {
            errorMessage.textContent = "Uwaga! Wpisany numer nie jest zgodny ze schematem numeru legitymacji.";
            errorMessage.style.display = 'block';
        }
        else {
            errorMessage.style.display = 'none';
        }
    })

    $("#addMember input[name='repeatlogin']").change(async function () {
        let login = $("#addMember input[name='login']");
        let repeatlogin = $("#addMember input[name='repeatlogin']");
        let errorMessage = document.querySelector('#error-message');

        if (repeatlogin.val() !== login.val()) {
            errorMessage.textContent = "Podane numery legitymacji nie są zgodne.";
            errorMessage.style.display = 'block';
        }
        else {
            errorMessage.style.display = 'none';
        }
    })


    $("#addMember_email").change(function () {
        if ($(this).val() !== "" && !$("#addMember_password").attr("disabled")) {
            $("#addMember_send_password").attr('disabled', false)
        } else {
            $("#addMember_send_password").attr('disabled', true)
        }
    })

    $("#addMember_send_password").change(function () {
        if ($(this).prop('checked')) {
            $("#addMember_password").attr('disabled', true);
        } else {
            $("#addMember_password").attr('disabled', false);
        }
    })

    $("#editStamp").on('file_submit', async function (event, {callback}) {
        let spinner = new Spinner();
        try {
            let response = await axios.post($(this).attr('action'), $(this).serialize());
            if (response.data.code !== 200) {
                if (response.data.errors) {
                    handleValidationErrors(response.data.errors, $(this));
                    enableFormBack(this);
                    spinner.destroy();
                    toastAlert('Wystąpił błąd podczas aktualizacji pieczątki.', {type: 'danger'})
                }

                return;
            }

            toastAlert('Pomyślnie zaktualizowano pieczątkę.', {type: 'success'})

            let form = $("#editStampModal form");
            enableFormBack(this);
            callback();

            let img = form.find('img');
            if ($("#editStampModal input[data-id]").length > 0) {
                img.attr('src', img.attr('src') + '?t=' + new Date().getTime());
                img.closest('.col-12').show();
            } else {
                img.closest('.col-12').hide();
            }

            spinner.destroy();
        } catch (err) {
            spinner.destroy();
            toastAlert('Wystąpił błąd podczas aktualizacji pieczątki.', {type: 'danger'})
        }
    })

    $("#editStampModal form").on('file_delete', function (e, file) {
        file.to_delete = true;

        $(this).find('input[data-id][data-type="to_delete"]').val('true')
        $(this).find('img').closest('.col-12').hide();
    })

    $("#activeMembersList, #guestsList, #archiveMembersList, #commercialMembersList").DataTable({
        order: [1, 'asc'],
        stateSave: false,
        drawCallback: function() {
            this.$('.forcePasswordChange').each(function() {
                new bootstrap.Tooltip(this, {html: true});
            })
        },
        columnDefs:[
            {
                targets: [0, 1],
                type: 'polstring',
            }
        ]
    });

    $("#districtShutdownsTable").DataTable({
        order: [0, 'desc'],
        stateSave: false,
    });

    let attorneysTable = $(".attorneysTable");

    attorneysTable.DataTable({
        'stateSave': false,
        'columnDefs': [
            {
                'targets': 2,
                'orderable': false
            },
            {
                targets: [0,1],
                type: 'polstring'
            }
        ],
        'order': [1, 'asc'],
    })

    $(attorneysTable.DataTable().$('.addProxy')).click(function(){
        let that = $(this);
        let proxy_id = that.data('id');
        let toAdd = that.data('add');
        let place = $('.proxy__place');
        let table = $('#proxiesTable');
        let tbody = table.find('tbody');
        let noProxies = tbody.find('.no__proxies');
        let full_name;
        if(toAdd){
            let input = $(`
                <input type="hidden" name="proxy_ids[]" value="${proxy_id}">
                `);
            place.append(input);
            that.data('add', false);
            that.html('Usuń');
            full_name = that.closest('tr').find('.user__first_name').html() + ' ' + that.closest('tr').find('.user__last_name').html();
            tbody.append($(`
                    <tr data-id="${proxy_id}"><td>${full_name}</td></tr>
                `))
            noProxies.hide();
        }else{
            place.find(`input[value=${proxy_id}]`).remove();
            tbody.find(`tr[data-id=${proxy_id}]`).remove();
            that.data('add', true);
            that.html('Wybierz');
            if(tbody.find('tr').length === 1){
                noProxies.show();
            }
        }
        that.toggleClass('btn-primary');
        that.toggleClass('btn-danger');

    })

        body.on('click', '.btnAttorneysManage', async function () {

            try {
                $('#member_name').text($(this).data('name'));
                let association_id = $(this).data('association_id');
                let member_id = $(this).data('member_id');

                let spinner = new Spinner();
                let response = await axios.get(url(`api/attorneys/${association_id}/${member_id}`));
                spinner.destroy();

                let members_without_attorney = response.data.members_without_attorney;
                let members_with_attorney = response.data.members_with_attorney;

                attorneysTable.api().clear();

                for (let member of members_with_attorney) {
                    let row = $('<tr />');
                    let button = `<button class="btn btn-sm btn-danger btnDeleteAttorney"
                data-proxy_id="${member.id}" data-id="${member_id}" data-association_id = "${association_id}">
                        <i class="fas fa-minus-circle me-2"></i>
                        Odbierz</button></td>`
                    row.append(`
                        <td>${member.user.first_name}</td>
                        <td>${member.user.last_name}</td>
                        <td>${button}</td>
                    `);
                    attorneysTable.api().rows.add(row).draw();
                }

                for (let member of members_without_attorney) {
                    let row = $('<tr />');

                    let button = `<button class="btn btn-sm btn-primary btnAddAttorney" data-proxy_id="${member.id}" data-id="${member_id}" data-association_id = "${member.association_id}" >
                        <i class="fas fa-plus-circle me-2" ></i>
                        Nadaj</button>`;

                    row.append(`
                        <td>${member.user.first_name}</td>
                        <td>${member.user.last_name}</td>
                        <td>${button}</td>
                    `);
                    attorneysTable.api().rows.add(row).draw();
                }

            } catch (err) {
                toastAlert('Wystąpił błąd poczas pobierania danych o pełnomocnictwach', {type: 'danger'});
            }

        })

    body.on('click', '.btnAddAttorney', async function() {
        try {
            let that = $(this);
            let proxy_id = that.data('proxy_id');
            let user_association_id = that.data('id');
            let association_id = that.data('association_id');

            let spinner = new Spinner();
            let response = await axios.post(url(`api/attorneys/admin-add`), {
                proxy_id: proxy_id,
                user_association_id: user_association_id,
                association_id: association_id,
            });

            if(response.data.status === 400){
                toastAlert('Nadawanie pełnomocnictwa nie powiodło się', {type: 'danger'});
                return;
            }

            spinner.destroy();
            that.addClass("btn-danger");
            that.removeClass("btn-primary");
            that.addClass("btnDeleteAttorney");
            that.removeClass("btnAddAttorney");
            that.html(`<i class='fas fa-minus-circle me-2'></i>Odbierz`);

            toastAlert('Pomyślnie dodano pełnomocnictwo');
        }catch(err){
            toastAlert('Nadawanie pełnomocnictwa nie powiodło się', {type: 'danger'});
        }
    });

    body.on('click', '.btnDeleteAttorney', async function() {

        try {
            let that = $(this);
            let proxy_id = that.data('proxy_id');
            let user_association_id = that.data('id');

            let spinner = new Spinner();
            let response = await axios.post(url(`api/attorneys/admin-delete`), {
                proxy_id: proxy_id,
                user_association_id: user_association_id
            });
            spinner.destroy();

            that.removeClass("btn-danger");
            that.addClass("btn-primary");
            that.removeClass("btnDeleteAttorney");
            that.addClass("btnAddAttorney");
            that.html(`<i class='fas fa-plus-circle me-2'></i>Nadaj`);

            toastAlert('Pomyślnie odebrano pełnomocnictwo');
        }catch(err){
            toastAlert('Usuwanie pełnomocnictwa nie powiodło się', {type: 'danger'});
        }


    });

    let regionSelect = $('#editDistrict_region_id');
    regionSelect.prepend(`<option value="0">Brak</option>`);
    let region = regionSelect.parent().parent().data('region') ?? '';

    if(region){
    }else{
        regionSelect.val(0);
    }

    //ustawianie modalu opcji eksportu zaleznie od wcisnietego przycisku
    $('button[data-bs-target="#membersListModal"]').click(function () {
        let modalNode = $("#membersListModal");
        let data = $(this).data('from');

        let checkboxes = modalNode.find('input[type="checkbox"]');
        checkboxes.prop('checked', false);
        modalNode.find('.one-table').hide();

        if (parseInt(data) === 1) {
            modalNode.find('#generateMemberList_active').prop('checked', true);
        } else if (parseInt(data) === 2) {
            modalNode.find('#generateMemberList_guests').prop('checked', true);
        } else if (parseInt(data) === 3) {
            modalNode.find('#generateMemberList_archive').prop('checked', true);
        }

    })

    $('#generateMemberList_active, #generateMemberList_guests, #generateMemberList_archive').change(function (){
        let modalNode = $("#membersListModal");
        let checkboxes = modalNode.find('.member-types').find('input[type="checkbox"]');
        let counter = 0;

        for(let checkbox of checkboxes){
            if($(checkbox).prop('checked')) {
                counter++;
            }
        }

        let div = modalNode.find('.one-table');

        if(counter >= 2){
            div.show();
            div.find('.status').hide();
        }else{
            div.hide();
            $('#generateMemberList_one_table').prop('checked', false);
        }
    })

    $('#generateMemberList_one_table').change(function() {

        let modalNode = $("#membersListModal");
        let statusCol = modalNode.find('.one-table').find('.status');

        if($(this).prop('checked')){
            statusCol.show();
        }else{
            statusCol.hide();
            statusCol.find('input[type="checkbox"]').prop('checked', false);
        }

    })

    $("#generateMemberList").on('submit', function(){
        enableFormBack();
    })
    //Dodawanie mysliwego komercyjnego

    let memberTypeSelect = $("#addMember_type_id");
    let memberTypeSelectEdit = $("#editMember_type_id");

    if(typeof(is_commercial) != 'undefined' || typeof(is_intern) != 'undefined' )
    {
        function generateLogin(length) {
            let result = '';
            let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            let charactersLength = characters.length;
            for (let i = 0; i < length; i++) {
                result += characters.charAt(Math.floor(Math.random() *
                    charactersLength));
            }
            return result;
        }

        let notForCommercial = $('.notForCommercial');
        let onlyForCommercial = $('.onlyForCommercial');
        let notForBookkeeper = $('.notForBookkeeper');
        let onlyForBookkeeper = $('.onlyForBookkeeper');
        let loginInput = $('#addMember_login, #editMember_login');
        let repeatLoginInput = $('#addMember_repeatlogin, #editMember_repeatlogin');
        let notForIntern = $('.notForIntern');
        let onlyForIntern = $('.onlyForIntern');

        if (is_commercial === true) {
            memberTypeSelect.val("6");

            notForBookkeeper.show();
            onlyForBookkeeper.hide();
            notForCommercial.hide();
            onlyForCommercial.show();
            if (loginInput.val() === '') {
                const login = generateLogin(150)
                loginInput.val(login);
            }

            repeatLoginInput.val(loginInput.val())
        }

        if (is_intern === true) {
            memberTypeSelect.val("11");

            notForBookkeeper.show();
            onlyForBookkeeper.hide();
           // notForCommercial.hide();

            notForIntern.hide();
            onlyForIntern.show();

            if (loginInput.val() === '') {
                const login = generateLogin(150)
                loginInput.val(login);
            }

            repeatLoginInput.val(loginInput.val())
        }

        memberTypeSelect.change(function () {

            let that = $(this);
            let selected = that.find('option:selected').val();

            loginInput.val('');
            repeatLoginInput.val('');

            if (parseInt(selected) === 6) {
                notForBookkeeper.show();
                onlyForBookkeeper.hide();
                notForCommercial.hide();
                onlyForCommercial.show();
                if (loginInput.val() === '') {
                    const login = generateLogin(150)
                    loginInput.val(login);
                }

                repeatLoginInput.val(loginInput.val())
            }else if(parseInt(selected) === 8){
                notForCommercial.show();
                onlyForCommercial.hide();
                notForBookkeeper.hide();
                onlyForBookkeeper.show();
                // if (loginInput.val() === '') {
                //     const login = generateLogin(150)
                //     loginInput.val(login);
                // }
            }else if(parseInt(selected) === 11){
                notForCommercial.show();
                onlyForCommercial.hide();
                notForIntern.hide();
                onlyForIntern.show();

                if (loginInput.val() === '') {
                    const login = generateLogin(150)
                    loginInput.val(login);
                }

                repeatLoginInput.val(loginInput.val())

            }else {
                notForCommercial.show();
                onlyForCommercial.hide();
                notForBookkeeper.show();
                onlyForBookkeeper.hide();
                onlyForIntern.hide();
                // if (loginInput.val() === '') {
                //     const login = generateLogin(150)
                //     loginInput.val(login);
                // }
            }
        })

        memberTypeSelectEdit.change(function () {

            function generateLogin(length) {
                let result = '';
                let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                let charactersLength = characters.length;
                for (let i = 0; i < length; i++) {
                    result += characters.charAt(Math.floor(Math.random() *
                        charactersLength));
                }
                return result;
            }

            let that = $(this);
            let selected = that.find('option:selected').val();
            let notForCommercial = $('.notForCommercial');
            let onlyForCommercial = $('.onlyForCommercial');
            let notForBookkeeper = $('.notForBookkeeper');
            let onlyForBookkeeper = $('.onlyForBookkeeper');
            let loginInput = $('#addMember_login, #editMember_login');
            let repeatLoginInput = $('#addMember_repeatlogin, #editMember_repeatlogin');
            let notForIntern = $('.notForIntern');
            let onlyForIntern = $('.onlyForIntern');

            // loginInput.val('');
            // repeatLoginInput.val('');

            if (parseInt(selected) === 6) {
                notForBookkeeper.show();
                onlyForBookkeeper.hide();
                notForCommercial.hide();
                onlyForCommercial.show();
                if (loginInput.val() === '') {
                    const login = generateLogin(150)
                    loginInput.val(login);
                }

                repeatLoginInput.val(loginInput.val())
            }else if(parseInt(selected) === 8){
                notForCommercial.show();
                onlyForCommercial.hide();
                notForBookkeeper.hide();
                onlyForBookkeeper.show();
                // if (loginInput.val() === '') {
                //     const login = generateLogin(150)
                //     loginInput.val(login);
                // }
            }else if(parseInt(selected) === 11){
                notForCommercial.show();
                onlyForCommercial.hide();
                notForIntern.hide();
                onlyForIntern.show();

                if (loginInput.val() === '') {
                    const login = generateLogin(150)
                    loginInput.val(login);
                }

                repeatLoginInput.val(loginInput.val())

            }else {
                notForCommercial.show();
                onlyForCommercial.hide();
                notForBookkeeper.show();
                onlyForBookkeeper.hide();
                // if (loginInput.val() === '') {
                //     const login = generateLogin(150)
                //     loginInput.val(login);
                // }
            }
        })

       // memberTypeSelect.trigger('change');

    }

    // import districts
    const importDistrictsModal = $('#importDistrictsModal');
    if (importDistrictsModal.length) {
        const form = importDistrictsModal.find('form')
        const fieldsContainer = importDistrictsModal.find('[data-app-fields_container]');
        let importFeatures = [];

        importDistrictsModal[0].addEventListener('show.bs.modal', function() {
            fieldsContainer.hide();
            fieldsContainer.empty();

            importFeatures = [];

            window.fileLists['files[]'] = [];
            renderList(form.find('[name="files[]"]'))
            importDistrictsModal.find('[data-app-file_container]').show();
        })

        $('#btnImportShpSubmit').click(async function () {
            fieldsContainer.find('.text-danger').remove();

            const checked = form.find('input[type="checkbox"]:checked');
            if(importFeatures.length) {
                if(checked.length) {
                    const districts = [];
                    checked.each(function() {
                        const inputName = $(this).attr('name');
                        const value = inputName.split('feature[')[1].split(']')[0]
                        const feature = importFeatures[parseInt(value)];

                        const potentialNames = ['F_R_NAME', 'NZW_NADL', 'ADR_LES', 'ADR_FOR'];
                        let name = 'Brak nazwy';
                        for(let prop of potentialNames) {
                            if(feature.get(prop)) {
                                name = feature.get(prop);
                                break;
                            }
                        }

                        let totalArea = null;
                        let forestArea = null;
                        let areaAfterShutdowns = null;

                        // try to get areas
                        try {
                            totalArea = feature.get('POW_BR')
                            forestArea = feature.get('POW_LES')
                            areaAfterShutdowns = feature.get('POW_NET')
                        } catch(err) {}

                        const coordinates = feature.getGeometry().getCoordinates().map(arr => arr.map(el => toLonLat(el).join(',')).join(' '))[0];

                        districts.push({
                            name,
                            coordinates,
                            totalArea,
                            forestArea,
                            areaAfterShutdowns
                        })
                    })

                    const spinner = new Spinner();
                    try {
                        const associationId = window._association_id;

                        const response = await axios.post(url('api/admin/districts/create'), {
                            associationId,
                            districts
                        })

                        if(response.data.code !== 200) {
                            toastAlert('Wystąpił błąd: ' + response.data.message, {type: 'danger'})
                        } else {
                            toastAlert('Pomyślnie dodano obwody');
                            window.location.reload();
                        }
                    } catch(err) {
                        toastAlert('Wystąpił błąd podczas próby utworzenia obwodów z zaimportowanych plików.', {type: 'danger'})
                    } finally {
                        spinner.destroy();
                    }
                } else {
                    fieldsContainer.append(`
                        <span class="text-danger">Musisz wybrać przynajmniej jeden obwód</span>
                    `);
                }

                return;
            }

            importFeatures = await handleShpForm(form)
            if (importFeatures.length) {
                fieldsContainer.append('<h5>Wybierz obwód</h5>')

                for(const index in importFeatures) {
                    const potentialNames = ['F_R_NAME', 'NZW_NADL', 'ADR_LES', 'ADR_FOR'];
                    let name = 'Brak nazwy';
                    for(let prop of potentialNames) {
                        if(importFeatures[index].get(prop)) {
                            name = importFeatures[index].get(prop);
                            break;
                        }
                    }

                    fieldsContainer.append(`
                        <div class="col-12">
                            <input class="form-check-input" id="feature-${index}" type="checkbox" name="feature[${index}]" />
                            <label class="form-check-label" for="feature-${index}">${name}</label>
                        </div>
                    `)
                }

                fieldsContainer.show();
                importDistrictsModal.find('[data-app-file_container]').hide();
            } else {
                confirmModal('W podanym pliku nie znaleziono geometrii lub geometria jest zepsuta')
            }
        })
    }


    body.on('click', '.btnEditLogin', async function () {
        let id = $(this).data('id');
        let form = $("#editLogin");
        let modal = $("#editLoginModal");

        form.attr('action', window._EDIT_LOGIN.replace('REPLACE_ID', id));

        let oldval = modal.find('[name="old-login"]').val();

        openModal('#editLoginModal')
    })


    handleApiForm('#editLogin', ({response, form}) => {
        if (response.data.code === 200) {
            closeModal('#editLoginModal');

            let login = response.data.login;

            let loginInput = $("#editMember input[name='login']");

            loginInput.val(login)

            emptyForm(form);
            toastAlert('Pomyślnie edytowano login');
        }
    })


    $("#editLogin input[name='login']").change(async function () {

        let modal = $("#editLoginModal");
        let loginPattern = /^[a-zA-Z]\d{8}$/; // Pattern: one letter followed by 8 digits
        let errorMessage = document.querySelector("#warning-message-2");

        if (!loginPattern.test($("#editLogin input[name='login']").val())) {
            errorMessage.textContent = "Uwaga! Wpisany numer nie jest zgodny ze schematem numeru legitymacji.";
            errorMessage.style.display = 'block';
        }
        else {
            errorMessage.style.display = 'none';
        }
    })

    $("#editLogin input[name='repeatlogin']").change(async function () {
        let login = $("#editLogin input[name='login']");
        let repeatlogin = $("#editLogin input[name='repeatlogin']");
        let errorMessage = document.querySelector('#warning-message-3');

        if (repeatlogin.val() !== login.val()) {
            errorMessage.textContent = "Podane numery legitymacji nie są zgodne.";
            errorMessage.style.display = 'block';
        }
        else {
            errorMessage.style.display = 'none';
        }
    })

    $("#editLogin input[name='oldlogin']").change(async function () {
        let old_login = $("#editLogin input[name='old-login']");
        let oldlogin = $("#editLogin input[name='oldlogin']");
        let errorMessage = document.querySelector('#warning-message-1');

        if (oldlogin.val() !== old_login.val()) {
            errorMessage.textContent = "Podano nieprawidłowy numer legitymacji.";
            errorMessage.style.display = 'block';
        }
        else {
            errorMessage.style.display = 'none';
        }
    })
}
